import { render, staticRenderFns } from "./PlayerTrophies.vue?vue&type=template&id=d20132aa&scoped=true"
import script from "./PlayerTrophies.vue?vue&type=script&lang=js"
export * from "./PlayerTrophies.vue?vue&type=script&lang=js"
import style0 from "./PlayerTrophies.vue?vue&type=style&index=0&id=d20132aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20132aa",
  null
  
)

export default component.exports